import { tokenizedFetch } from '../../tokenizedFetch';
import { logger } from '../logger';
import { EndPoints } from './authService';
/**
 *
 * @param url
 * @param options
 */
function tokenisedFailureLoggedFetch(url, options = {}) {
    return tokenizedFetch(url, options).then(async (r) => {
        var _a;
        if (!r.ok && r.type !== 'opaqueredirect' && r.type !== 'opaque') {
            logger.error('Failure', await ((_a = r.text) === null || _a === void 0 ? void 0 : _a.call(r)));
        }
        return r;
    });
}
/**
 *
 * @param authVerificationUrl
 */
export function fetchSessionInfoService(authVerificationUrl) {
    return tokenisedFailureLoggedFetch(authVerificationUrl, {
        credentials: 'include',
    });
}
/**
 *
 * @param thoughtSpotHost
 */
export async function fetchLogoutService(thoughtSpotHost) {
    return tokenisedFailureLoggedFetch(`${thoughtSpotHost}${EndPoints.LOGOUT}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'x-requested-by': 'ThoughtSpot',
        },
    });
}
//# sourceMappingURL=tokenizedAuthService.js.map